import React, { useState, useRef, useEffect } from "react";

export const CITY_LIST: string[] = [
  // 특별시·광역시
  "서울특별시", "부산광역시", "대구광역시", "인천광역시",
  "광주광역시", "대전광역시", "울산광역시", "세종특별자치시",
  // 경기도
  "수원시", "성남시", "용인시", "고양시", "부천시", "안양시",
  "남양주시", "화성시", "안산시", "파주시", "의정부시", "평택시",
  "시흥시", "광명시", "김포시", "하남시", "오산시", "이천시",
  "군포시", "과천시", "의왕시", "안성시", "여주시", "양주시",
  "구리시", "동두천시", "포천시", "양평군", "가평군", "연천군",
  // 강원특별자치도
  "춘천시", "원주시", "강릉시", "속초시", "동해시", "삼척시",
  "태백시", "홍천군", "철원군", "평창군", "정선군", "영월군",
  "인제군", "고성군", "양구군",
  // 충청북도
  "청주시", "충주시", "제천시", "진천군", "음성군", "증평군",
  "괴산군", "보은군", "옥천군", "영동군", "단양군",
  // 충청남도
  "천안시", "아산시", "공주시", "홍성군", "보령시", "서산시",
  "논산시", "당진시", "예산군", "태안군", "계룡시", "금산군",
  "부여군", "청양군", "서천군",
  // 전라북도
  "전주시", "군산시", "익산시", "정읍시", "남원시", "김제시",
  "완주군", "진안군", "무주군", "임실군", "순창군", "고창군", "부안군",
  // 전라남도
  "목포시", "순천시", "여수시", "나주시", "광양시",
  "담양군", "고흥군", "해남군", "장흥군", "보성군",
  "강진군", "완도군", "진도군", "신안군",
  // 경상북도
  "포항시", "경주시", "안동시", "구미시", "영주시", "경산시",
  "김천시", "상주시", "문경시", "영천시", "칠곡군",
  "의성군", "군위군", "청송군", "영덕군", "울진군",
  "봉화군", "예천군", "청도군", "고령군", "성주군", "영양군", "울릉군",
  // 경상남도
  "창원시", "진주시", "통영시", "거제시", "양산시", "밀양시",
  "김해시", "사천시", "함안군", "거창군", "합천군",
  "고성군", "남해군", "하동군", "산청군", "함양군", "의령군", "창녕군",
  // 제주특별자치도
  "제주시", "서귀포시",

  // 일본
  "도쿄", "오사카", "나고야", "후쿠오카", "삿포로", "교토",
  "고베", "히로시마", "센다이", "나하",
  // 중국
  "베이징", "상하이", "광저우", "선전", "청두", "충칭",
  "시안", "우한", "난징", "항저우",
  // 대만·홍콩
  "홍콩", "마카오", "타이베이", "타이중", "가오슝",
  // 동남아시아
  "방콕", "치앙마이", "싱가포르", "쿠알라룸푸르", "페낭",
  "자카르타", "발리", "수라바야", "마닐라", "세부",
  "하노이", "호치민", "다낭", "양곤", "프놈펜", "비엔티안",
  // 남아시아
  "뉴델리", "뭄바이", "콜카타", "방갈로르", "첸나이",
  "하이데라바드", "다카", "카라치", "이슬라마바드", "콜롬보", "카트만두",
  // 중앙아시아
  "타슈켄트", "알마티", "아스타나", "비슈케크", "두샨베",
  // 중동
  "두바이", "아부다비", "도하", "리야드", "이스탄불",
  "앙카라", "테헤란", "바그다드", "베이루트", "암만",
  // 유럽
  "런던", "파리", "베를린", "마드리드", "바르셀로나",
  "로마", "밀라노", "암스테르담", "브뤼셀", "취리히",
  "비엔나", "뮌헨", "함부르크", "코펜하겐", "스톡홀름",
  "오슬로", "헬싱키", "더블린", "리스본", "아테네",
  "부다페스트", "프라하", "바르샤바", "모스크바", "상트페테르부르크",
  "키이우",
  // 북미
  "뉴욕", "로스앤젤레스", "시카고", "댈러스", "휴스턴",
  "워싱턴DC", "보스턴", "필라델피아", "마이애미", "애틀랜타",
  "샌프란시스코", "시애틀", "포틀랜드", "덴버", "피닉스",
  "라스베이거스", "샌디에이고", "미니애폴리스",
  "토론토", "밴쿠버", "몬트리올", "캘거리", "오타와",
  "멕시코시티",
  // 남미
  "상파울루", "리우데자네이루", "부에노스아이레스",
  "보고타", "리마", "산티아고", "브라질리아", "카라카스",
  // 오세아니아
  "시드니", "멜버른", "브리즈번", "퍼스", "애들레이드",
  "골드코스트", "캔버라", "오클랜드", "웰링턴", "크라이스트처치",
  // 아프리카
  "카이로", "나이로비", "요하네스버그", "케이프타운",
  "라고스", "아디스아바바", "카사블랑카", "다카르",
  // 몽골
  "울란바토르",
];

interface Props {
  value: string;
  onChange: (v: string) => void;
  inputStyle?: React.CSSProperties;
  disabled?: boolean;
}

export function CityAutocomplete({ value, onChange, inputStyle, disabled }: Props) {
  const [query, setQuery]   = useState(value);
  const [open, setOpen]     = useState(false);
  const wrapRef             = useRef<HTMLDivElement>(null);

  useEffect(() => { setQuery(value); }, [value]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const matches = query.length >= 1
    ? CITY_LIST.filter(c => c.includes(query)).slice(0, 10)
    : [];

  const select = (city: string) => {
    onChange(city);
    setQuery(city);
    setOpen(false);
  };

  return (
    <div ref={wrapRef} style={{ position: "relative", width: "100%" }}>
      <input
        value={query}
        disabled={disabled}
        placeholder="도시명 입력 (예: 서울특별시, 도쿄)"
        style={{
          width: "100%",
          padding: "10px 12px",
          border: "1.5px solid #e0d5c8",
          borderRadius: 10,
          fontSize: "0.9rem",
          color: "#3d2b1f",
          background: disabled ? "#f5f0ea" : "#fdfaf7",
          fontFamily: "inherit",
          cursor: disabled ? "not-allowed" : "text",
          outline: "none",
          ...inputStyle,
        }}
        onChange={e => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => { if (query.length >= 1) setOpen(true); }}
        onKeyDown={e => {
          if (e.key === "Escape") setOpen(false);
          if (e.key === "Enter" && matches.length === 1) { select(matches[0]); e.preventDefault(); }
        }}
      />
      {open && matches.length > 0 && (
        <div style={{
          position: "absolute",
          top: "calc(100% + 4px)",
          left: 0, right: 0,
          background: "#fff",
          border: "1.5px solid #c09a6b",
          borderRadius: 10,
          boxShadow: "0 6px 20px rgba(100,70,40,0.15)",
          zIndex: 200,
          maxHeight: 220,
          overflowY: "auto",
        }}>
          {matches.map((city, i) => (
            <div
              key={city}
              onMouseDown={() => select(city)}
              style={{
                padding: "9px 14px",
                cursor: "pointer",
                fontSize: "0.88rem",
                color: "#3d2b1f",
                borderBottom: i < matches.length - 1 ? "1px solid #f0e8df" : "none",
                transition: "background 0.1s",
              }}
              onMouseEnter={e => (e.currentTarget.style.background = "#fff8f2")}
              onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
            >
              {city}
            </div>
          ))}
        </div>
      )}
      <div style={{
        fontSize: "0.72rem",
        color: "#9c7b5a",
        marginTop: 4,
        lineHeight: 1.5,
      }}>
        태어난 도시를 모르시는 경우 <strong>'서울특별시'</strong> 혹은 태어난 국가의 수도를 입력해주세요.
      </div>
    </div>
  );
}
